<template>
	<div class="base">
		<router-view />
	</div>
</template>

<script>
export default {};
</script>
